export const STATES = [
  'AK',
  'AL',
  'AR',
  'AS',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'FM',
  'GA',
  'GU',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MH',
  'MI',
  'MN',
  'MO',
  'MP',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'PW',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VI',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
];

export const GENDER_MALE = 'Male';
export const GENDER_FEMALE = 'Female';
export const GENDER_TRANS_MALE = 'Transgender Male';
export const GENDER_TRANS_FEMALE = 'Transgender Female';
export const GENDER_NON_BINARY = 'Non-Binary';

export const GENDER_OTHER = 'Other';

export type GenderType =
  | typeof GENDER_MALE
  | typeof GENDER_FEMALE
  | typeof GENDER_TRANS_MALE
  | typeof GENDER_TRANS_FEMALE
  | typeof GENDER_NON_BINARY;

export const WARDROBE_GENDERS = [
  GENDER_MALE,
  GENDER_FEMALE,
  GENDER_NON_BINARY,
  GENDER_OTHER,
] as const;

export type WardrobeGenderType = typeof WARDROBE_GENDERS[number];

export const PROFILE_GENDER_TO_WARDROBE_GENDER = {
  [GENDER_TRANS_MALE]: GENDER_MALE,
  [GENDER_TRANS_FEMALE]: GENDER_FEMALE,
  'Prefer Not To Say': GENDER_OTHER,
} as const;

export const GENDER_IDENTITIES = [
  GENDER_MALE,
  GENDER_FEMALE,
  GENDER_TRANS_MALE,
  GENDER_TRANS_FEMALE,
  GENDER_NON_BINARY,
];

export const GENDER_IDENTITIES_OPTIONS = GENDER_IDENTITIES.map((gender) => ({
  value: gender,
  label: gender,
}));

export const ETHNICITIES = [
  'African American',
  'African Descent',
  'Caribbean / West Indies',
  'Caucasian',
  'East Asian',
  'Eastern European',
  'Ethnically Ambiguous',
  'Hispanic / Latinx',
  'Mediterranean',
  'Middle Eastern',
  'Native American / Alaskan',
  'Pacific Islander / Hawaiian',
  'South American',
  'South Asian / East Indian',
  'Southeast Asian',
] as const;

export type US_ETHNICITY_TYPE = typeof ETHNICITIES[number];

export const UK_ETHNICITIES = [
  'African - Central',
  'African - Eastern',
  'African - Southern',
  'African - Western',
  'Afro Caribbean / West Indies',
  'Australasia',
  'Central Asia',
  'East Asian',
  'Eastern European',
  'Latin American',
  'Mediterranean',
  'Middle Eastern',
  'North African',
  'North American',
  'Northern European',
  'Pacific Islander / Hawaiian',
  'Scandinavian',
  'South American',
  'South Asian / East Indian',
  'Mixed Race',
] as const;

export type UK_ETHNICITY_TYPE = typeof UK_ETHNICITIES[number];

export const US_ETHNICITY_MAP = {
  Caucasian: 'Caucasian / White',
  'African American': 'African American / Black',
};

export const UK_COUNTRY = 'United Kingdom';
